// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_pg-0";